export default {
  props: {
    channel: {
      type: Object,
      required: true,
      default: () => ({})
    },
    mpe: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/standard/preview/props.js